"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationRent = void 0;
const infrastructure_1 = require("../../../infrastructure");
const Currency_1 = require("../../../money/domain/Currency");
const utils_1 = require("@leavy/utils");
class AccommodationRent extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.value) && this.value >= 0
            && utils_1.Guard.isNotNullish(this.currency) && Currency_1.Currency.isCurrency(this.currency));
    }
    toPlain() {
        return { ...this };
    }
}
exports.AccommodationRent = AccommodationRent;
//# sourceMappingURL=AccommodationRent.js.map